import type { LogRow } from '../api/client'

/** Stable identity shared by rendering, pagination and the live tail. */
export function logRowIdentity(row: LogRow): string {
  return row._tier1_id ?? `logs:${row.id}`
}

/** Keep the first occurrence of each stored row identity and add it to seen. */
export function dedupeLogRows(rows: LogRow[], seen: Set<string> = new Set()): LogRow[] {
  return rows.filter(row => {
    const identity = logRowIdentity(row)
    if (seen.has(identity)) return false
    seen.add(identity)
    return true
  })
}
